/**
 * A2 Phase 1 reciprocal links (Oct 2026).
 *
 * Sprint A's intent map already carries the forward arrow (fee page → answer
 * page, AJIO process page → AJIO service page). It is left untouched. This map
 * adds the RETURN arrow so each pair reads as two differentiated sub-intents
 * rather than one page pointing away from the other.
 *
 * No redirects, no canonical changes, no deindexing — a contextual link only.
 */
export const A2_SIBLING_LINKS = {
  '/answers/blinkit-onboarding-cost': {
    to: '/blinkit-commission',
    anchor: 'Blinkit commission rates & rate card',
    note: 'This page covers what onboarding costs a brand. Looking for what Blinkit deducts per order instead?',
  },
  '/answers/zepto-onboarding-cost': {
    to: '/zepto-commission',
    anchor: 'Zepto commission & OB fee deduction',
    note: 'This page covers what onboarding costs a brand. Looking for commission rates and OB fee deduction instead?',
  },
  '/ajio-seller-registration': {
    to: '/ajio/ajio-seller-onboarding-process',
    anchor: 'How the AJIO onboarding process works',
    note: 'This is our done-for-you registration service. Want to understand the portal stages first?',
  },
  // Oct 2026 — supports the Zepto vendor-portal and Nykaa portal/login query
  // families identified in the Oct-23 GSC export.
  '/marketplace/zepto/vendor-registration': {
    to: '/services/zepto',
    anchor: 'Zepto vendor registration & onboarding support',
    note: 'This page explains how vendor registration and portal access work. Want it handled for you?',
  },
  '/marketplace/nykaa/seller-registration': {
    to: '/nykaa-seller-onboarding-guide',
    anchor: 'Nykaa seller portal & login explained',
    note: 'Looking for how portal access and seller login are issued after approval?',
  },
};

export const siblingFor = (path) => {
  if (!path) return null;
  const clean = (path.split('?')[0].split('#')[0].replace(/\/+$/, '') || '/').toLowerCase();
  return A2_SIBLING_LINKS[clean] || null;
};

export default A2_SIBLING_LINKS;
